import React from 'react'
import ProTeacherProductList from './components/ProTeacherProductList'

const ProTeacherSkillBox = () => {
  return (
  <>
  
    <ProTeacherProductList />
  </>
  )
}

export default ProTeacherSkillBox
